import { useEffect } from "react";

/**
 * Shows the browser's native "leave site?" dialog on refresh, tab close or
 * external navigation while `hasUnsavedChanges` is true. Browsers ignore any
 * custom message; calling preventDefault and setting returnValue is what
 * triggers the prompt. In-app route changes are not intercepted.
 */
export const useUnsavedChangesWarning = (hasUnsavedChanges: boolean): void => {
  useEffect(() => {
    if (!hasUnsavedChanges) return;

    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [hasUnsavedChanges]);
};
